import * as React from "react";
/* empty css                       */
const ProductBlockInner = ({ children }) => {
  return /* @__PURE__ */ React.createElement("div", { className: "product-block-inner" }, children);
};
export {
  ProductBlockInner
};
//# sourceMappingURL=ProductBlockInner.js.map
